import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'

import { displayMessages } from './common'

export function getGarantias(page = 1) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const showRecords = getState().garantias.get('showRecords')
		const orderBy = getState().garantias.get('orderBy')
		const filters = getState().garantias.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()
		axios.get(`${API_URL}/garantias`, { params: { page, showRecords, orderBy, filters }})
		.then((res) => {

			const data = res.data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
			const totalRecords = Number(res.data.totalRecords)
			const fn1 = d => d({ type: types.OBTENER_GARANTIAS, payload: { data, page, totalRecords } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}

export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.CAMBIAR_MOSTRAR_REGISTROS_GARANTIAS, payload: showRecords })
        const fn1 = (d) => d(getGarantias(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function toggleSelectItem(id, checked) {
	return (dispatch, getState) => {
		const index = getState().garantias.get('garantias').findIndex(x => x.get('id') === id)
		dispatch({ type: types.CONMUTAR_SELECCION_GARANTIA, payload: { index, checked } })
	}
}

export function toggleSelectAllItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_GARANTIAS, payload: checked })
	}
}

export function filterGarantias(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_GARANTIAS, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().garantias.get('orderBy')
		current = current.set('field', field.Value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}

        const fn0 = (d) => d({ type: types.ORDENAR_GARANTIAS, payload: { orderBy: current } })
        const fn1 = (d) => d(getGarantias(1))
        fn0(dispatch)
        fn1(dispatch)
	}
}

export function displayModalCreate(show, title, mode, id) {
	return (dispatch, getState) => {
		const user = getState().common.get('user')
		dispatch({ type: types.MOSTRAR_MODAL_CREAR_GARANTIA, payload: { show, title, mode, id, user } })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_GARANTIAS, payload: { path, value } })
	}
}

export function createOrUpdateGarantias(data, mode) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_GARANTIAS, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_GARANTIAS, payload: false })
		fn0(dispatch)
		if (mode === 'create') {
			axios.post(`${API_URL}/garantias`, data.toJS())
				.then(res => {
					const garantia = res.data
					garantia.visible = true
					garantia.selected = false
					dispatch({ type: types.CREAR_ACTUALIZAR_GARANTIA, payload: garantia })
					displayMessages(dispatch, { success: 'El garantia ha sido guardado exitosamente' })
					fn1(dispatch)
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		} else if (mode === 'edit') {
			axios.put(`${API_URL}/garantias/${data.get('id')}`, data.toJS())
				.then(res => {
					const garantia = res.data
					garantia.visible = true
					garantia.selected = false
					dispatch({ type: types.CREAR_ACTUALIZAR_GARANTIA, payload: garantia })
					displayMessages(dispatch, { success: 'El garantia ha sido actualizado exitosamente' })
					fn1(dispatch)
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		}
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_GARANTIA, payload: { open, message, action } })
	}
}

export function deleteGarantias() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().garantias.get('garantias').filter(x => x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/garantias/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.Nombre)
					dispatch({ type: types.ELIMINAR_GARANTIA, payload: x.result.data.id })
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes garantias: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})
	}
}

export function showHideModalFilter(state) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_GARANTIAS, payload: state })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_GARANTIAS })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_GARANTIAS })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_GARANTIAS, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_GARANTIAS, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_GARANTIAS })
        const fn1= (d) => d(getGarantias(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}


// WEBPACK FOOTER //
// ./src/actions/garantias.js